import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">常见问答</h2>
          <p className="text-sm text-foreground-600 mt-3">关于51吃瓜在线的常见问题解答</p>
        </div>
        <div className="max-w-3xl mx-auto space-y-4">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg px-6 py-5 border border-background-200/70"
            >
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                <span className="text-accent-500 mr-2">Q{i + 1}.</span>
                {item.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-7">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}